import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { Lock, Loader2, ArrowLeft, Eye, EyeOff, CheckCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [form, setForm] = useState({ password: '', confirm: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) { toast.error('Password must be at least 6 characters'); return; }
    if (form.password !== form.confirm) { toast.error('Passwords do not match'); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, password: form.password });
      setDone(true);
      toast.success('Password reset successfully');
      setTimeout(() => navigate('/login'), 2000);
    } catch (error) { toast.error(error.response?.data?.detail || 'Reset failed'); }
    finally { setLoading(false); }
  };

  return (
    <div className="auth-page" data-testid="reset-password-page">
      <div className="auth-card">
        <div className="auth-logo">
          <div className="auth-logo-icon">D</div>
          <h1>DepinaCRM</h1>
        </div>
        {!done ? (
          <>
            <h2>Set new password</h2>
            <form onSubmit={handleSubmit} className="auth-form">
              <div className="auth-field">
                <label>New Password</label>
                <div className="password-field">
                  <input type={showPassword ? 'text' : 'password'} value={form.password}
                    onChange={(e) => setForm(p => ({ ...p, password: e.target.value }))}
                    placeholder="Min 6 characters" data-testid="reset-password" />
                  <button type="button" className="toggle-pw" onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                  </button>
                </div>
              </div>
              <div className="auth-field">
                <label>Confirm Password</label>
                <input type="password" value={form.confirm}
                  onChange={(e) => setForm(p => ({ ...p, confirm: e.target.value }))}
                  placeholder="Confirm password" data-testid="reset-confirm" />
              </div>
              <button type="submit" className="auth-submit" disabled={loading} data-testid="reset-submit">
                {loading ? <Loader2 className="animate-spin" size={18} /> : <Lock size={18} />}
                {loading ? 'Resetting...' : 'Reset Password'}
              </button>
            </form>
          </>
        ) : (
          <div className="auth-success">
            <CheckCircle size={48} className="auth-success-icon" />
            <h2>Password Reset</h2>
            <p>Redirecting to sign in...</p>
          </div>
        )}
        <Link to="/login" className="auth-back"><ArrowLeft size={16} /> Back to sign in</Link>
      </div>
    </div>
  );
}
